var map = {
	"./index.vue": 78251,
	"./launch.vue": 83638,
	"./myToken.vue": 13160,
	"./ranking.vue": 87020,
	"./referral.vue": 3655,
	"./reward.vue": 87390,
	"./token/_id.vue": 31710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45535;